/*
 *
 * Dashboard constants
 *
 */

const constantKey = 'app/containers/Dashboard';

const dashboardConstants = {
  DEFAULT_ACTION: `${constantKey}/DEFAULT_ACTION`,
  DEFAULT_ACTION_SUCCESS: `${constantKey}/DEFAULT_ACTION_SUCCESS`,
  DEFAULT_ACTION_ERROR: `${constantKey}/DEFAULT_ACTION_ERROR`,
  
  // Information constants
  FETCH_INFORMATION: `${constantKey}/FETCH_INFORMATION`,
  FETCH_INFORMATION_SUCCESS: `${constantKey}/FETCH_INFORMATION_SUCCESS`,
  FETCH_INFORMATION_ERROR: `${constantKey}/FETCH_INFORMATION_ERROR`,

  GET_TREE_TOKEN: `${constantKey}/GET_TREE_TOKEN`,
  GET_TREE_TOKEN_SUCCESS: `${constantKey}/GET_TREE_TOKEN_SUCCESS`,
  GET_TREE_TOKEN_ERROR: `${constantKey}/GET_TREE_TOKEN_ERROR`,

  // Wallet Summary constants
  GET_WALLET_SUMMARY: `${constantKey}/GET_WALLET_SUMMARY`,
  GET_WALLET_SUMMARY_SUCCESS: `${constantKey}/GET_WALLET_SUMMARY_SUCCESS`,
  GET_WALLET_SUMMARY_ERROR: `${constantKey}/GET_WALLET_SUMMARY_ERROR`,
};

export default dashboardConstants;
